import { render, staticRenderFns } from "./InnsatsStandardPage.vue?vue&type=template&id=9201ec56"
import script from "./InnsatsStandardPage.vue?vue&type=script&lang=js"
export * from "./InnsatsStandardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports